<button 
  [type]="type"
  [ngClass]="classes"
  [disabled]="disabled || loading"
  (click)="buttonClickFn($event)"
  (appClickOutside)="clickedOutside($event)">
    <ng-content></ng-content>
</button>